import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getFeedingBargesList as getFeedingBargesListApi,
	getFeedingBarges as getFeedingBargesApi,
	addNewFeedingBarges as addNewFeedingBargesApi,
	updateFeedingBarges as updateFeedingBargesApi,
	deleteFeedingBarges as deleteFeedingBargesApi,
} from '../../helpers/establishment/backend_helper';

export const getFeedingBargesList = createAsyncThunk('feedingBarges/getFeedingBargesList', async () => {
	try {
		const response = getFeedingBargesListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getFeedingBarges = createAsyncThunk('feedingBarges/getFeedingBarges', async feedingBarges_id => {
	try {
		const response = getFeedingBargesApi(feedingBarges_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewFeedingBarges = createAsyncThunk('feedingBarges/addNewFeedingBarges', async feedingBarges => {
	try {
		const response = addNewFeedingBargesApi(feedingBarges);
		toast.success('Artefacto Naval agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar feedingBarges.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateFeedingBarges = createAsyncThunk('feedingBarges/updateFeedingBarges', async (feedingBarges) => {
		try {
			const response = updateFeedingBargesApi(feedingBarges);
			toast.success('Artefacto Naval actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar feedingBarges.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deleteFeedingBarges = createAsyncThunk('feedingBarges/deleteFeedingBarges', async feedingBarges => {
	try {
		const response = await deleteFeedingBargesApi(feedingBarges);
		toast.success('Artefacto Naval eliminado exitosamente.', { autoClose: 3000 });
		return { feedingBarges, ...response };
	} catch (error) {
		toast.error('Error al eliminar feedingBarges.', { autoClose: 3000 });
		throw new Error(error);
	}
});


